import { render } from "./ActivePlayerArea.vue?vue&type=template&id=89659fa4&ts=true"
import script from "./ActivePlayerArea.vue?vue&type=script&lang=ts"
export * from "./ActivePlayerArea.vue?vue&type=script&lang=ts"

import "./ActivePlayerArea.vue?vue&type=style&index=0&id=89659fa4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__